import styled from '@emotion/styled';

export const StyledDateRangeContainer = styled.div`
  font-size: 14px;
  color: #939bb0;
`;
